import Privacy from "../src/Components/privacy/index"
import './App.css';

function App() {
  return (
    <div className="mt-[50px]">
      <Privacy />
  </div>
  );
}
export default App;
